<template>
    <div>
        <h1>{{$t('help.title')}}</h1>
        <router-link :to="{ name: 'styleguide' }" class="button--cta">Styleguide</router-link>
        <router-link :to="{ name: 'guidelines' }" class="button--cta">Guidelines</router-link>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class Help extends Vue {
        name = 'help';
    }

    Vue.component('help', Help);
</script>



// WEBPACK FOOTER //
// src/pages/Help.vue